export enum ReferenceLabelTypeEnum {
  CONTRACT = 'contract',
  CASE = 'case',
  VOUCHER = 'voucher',
}

export type ReferenceLabelType =
  | ReferenceLabelTypeEnum.CASE
  | ReferenceLabelTypeEnum.CONTRACT
  | ReferenceLabelTypeEnum.VOUCHER;
